import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import LandingSacadaSP from "../pages/landing-sacada-sp/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/fechamento-sacada-sp",
    element: <LandingSacadaSP />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;